export default "__VITE_ASSET__DWFBdMIv__"